import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';
import { DateTimeFormatPipe } from '@cue/pipes';
import { ImageComponent } from '@cue/images';
import { UnitInfo, UnitInfoStatus } from '@cue/navigation-services';
import { ImgBlobPipe } from '../../pipes/img-blob';

@Component({
  selector: 'cue-unit-detail',
  imports: [TranslocoPipe, ImageComponent, ImgBlobPipe, DateTimeFormatPipe],
  templateUrl: './unit-detail.component.html',
  styleUrls: ['./unit-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitDetailComponent {
  translation = translation;

  showTitle = input<boolean, boolean | 'true' | 'false'>(true, {
    transform: booleanAttribute,
  });
  unitInfo = input.required<UnitInfo>();
  protected readonly UnitInfoStatus = UnitInfoStatus;
}
